import {
  AnalyticsService,
  GOOGLE_ANALYTICS_ACCOUNT_KEY,
  GoogleAnalyticsService,
  NoopAnalyticsService
} from './analytics.service';
import { ApiBase } from './base-api.service';
import { CacheService } from './cache.service';
import { CacheFactoryCacheService } from './cachefactory.service';
import { IdapService } from './idap.service';
import {
  KeybindService,
  KeybindDescription,
  KEYBOARD_CODES,
  KEYBOARD_MODIFIERS
} from './keybind.service';
import { MarketService } from './market.service';
import { PropertyService } from './property.service';
import { ShellService } from './shell.service';
import { StaticDataService } from './staticdata.service';
import { DecryptionService } from './decryption.service';
import { RateLimitUiService } from './rate-limit-ui.service';
import { RateLimitService } from './rate-limit.service';
import { RecaptchaService } from './recaptcha.service';
import { RequestQueueService } from './request-queue.service';

export const SERVICES = [
  CacheFactoryCacheService,
  CacheService,
  KeybindService,
  ShellService,
  MarketService,
  PropertyService,
  RateLimitService,
  RateLimitUiService,
  RequestQueueService,
  RecaptchaService,
  ShellService,
  IdapService,
  StaticDataService,
  DecryptionService,
  { provide: CacheService, useClass: CacheFactoryCacheService }
];

export {
  AnalyticsService,
  ApiBase,
  CacheService,
  GOOGLE_ANALYTICS_ACCOUNT_KEY,
  GoogleAnalyticsService,
  IdapService,
  KeybindDescription,
  KeybindService,
  KEYBOARD_CODES,
  KEYBOARD_MODIFIERS,
  MarketService,
  NoopAnalyticsService,
  PropertyService,
  RateLimitService,
  RateLimitUiService,
  RequestQueueService,
  RecaptchaService,
  ShellService,
  StaticDataService,
  DecryptionService
}



// WEBPACK FOOTER //
// ./src/app/core/services/index.ts